/**
 * Router instance (ARCHITECTURE.md §8).
 *
 * File-based tree generated by `@tanstack/router-plugin` (`routeTree.gen.ts`).
 * The router carries the shared `QueryClient` as context so route loaders can
 * `ensureQueryData` for prefetch, and `defaultPreload: 'intent'` warms a route's
 * loader on link hover for instant navigation.
 */
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/query";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
